export default __webpack_public_path__ + "static/banner-dot-68513f7a2c8281d539081151ee45031b.svg";